export enum GetCompareNPIDetailsActionDispatchTypes {
    GET_COMPARE_NPI_DETAILS_SUCCESS = "GET_COMPARE_NPI_DETAILS_SUCCESS",
    GET_COMPARE_NPI_DETAILS_ERROR = "GET_COMPARE_NPI_DETAILS_ERROR",
    GET_COMPARE_NPI_DETAILS_INVOKE = "GET_COMPARE_NPI_DETAILS_INVOKE",
    GET_COMPARE_NPI_DETAILS_RESET = "GET_COMPARE_NPI_DETAILS_RESET",
  }